import { render, staticRenderFns } from "./DotacaoElementoPrimarioConsolidado.vue?vue&type=template&id=c7d9dae6&scoped=true"
import script from "./DotacaoElementoPrimarioConsolidado.vue?vue&type=script&lang=js"
export * from "./DotacaoElementoPrimarioConsolidado.vue?vue&type=script&lang=js"
import style0 from "./DotacaoElementoPrimarioConsolidado.vue?vue&type=style&index=0&id=c7d9dae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d9dae6",
  null
  
)

export default component.exports